"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FavoritesLink = exports.FavoriteListsLink = void 0;
const FavoritesLink = exports.FavoritesLink = '/favourite-products';
const FavoriteListsLink = exports.FavoriteListsLink = '/favourite-lists';